import React from 'react'
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody from '../component/Casestudybody45';
import Footer from '../component/Footer'
import { Helmet } from 'react-helmet';

const CaseStudy45 = ({setBlank}) => {
     
    const headings = "<h2 style='display:inline-block;color:#ffffff;'>Enterprise Risk Management </h2><h4>Comprehensive ERM framework for a family office</h4>";

  return (
    <>
        <Helmet>
        <title>Enterprise Risk Management Comprehensive ERM framework for a family office</title>
        <meta property="og:title" content="Enterprise Risk Management Comprehensive ERM framework for a family office" />
        <meta property='og:description' content='Enterprise Risk Management Comprehensive ERM framework for a family office'/>
        <meta name='keywords' content=''/>
        </Helmet>

        <Menu setBlank={setBlank}  />
        <HeaderCasestudy class="header-casestudy45" headings={headings} />  
        <Casestudybody />
        <Footer setBlank={setBlank} />
    </>
  )
}

export default CaseStudy45
